/**
 * Función para consolidar indicadores sumando todos los reportes
 * y formatearlos para su visualización en tablas.
 */

export function parseReportToTable(data) {
  // El mapa donde acumularemos los valores, en JS no definimos el tipo del objeto
  const consolidatedMap = {};

  if (!data || !data.data) return [];

  // Iterar sobre todas las fechas
  Object.keys(data.data).forEach(date => {
    const dateData = data.data[date];

    // Iterar sobre cada empresa
    Object.keys(dateData).forEach(companyKey => {
      const company = dateData[companyKey];

      // Iterar sobre cada grupo de indicadores
      Object.keys(company).forEach(groupKey => {
        if (groupKey === 'company_type' || groupKey === 'indicator_name') {
          return; // Saltar estos campos
        }

        const group = company[groupKey];

        // Iterar sobre cada indicador dentro del grupo
        Object.keys(group).forEach(indicatorKey => {
          const indicator = group[indicatorKey];

          // Extraer el nombre del indicador
          const indicatorName = indicatorKey.split('__')[1]?.replace(/_/g, ' ') || indicatorKey;

          // Si no existe en el mapa, inicializarlo (objeto JS plano)
          if (!consolidatedMap[indicatorKey]) {
            consolidatedMap[indicatorKey] = {
              indicador: indicatorName.charAt(0).toUpperCase() + indicatorName.slice(1),
              resultado: 0,
              terminos: {},
              unidad: indicator.indicator_unit || '%'
            };
          }

          // Sumar el resultado (extraer el número del string)
          if (indicator.result) {
            const resultValue = parseFloat(indicator.result.toString().replace('%', '').trim());
            if (!isNaN(resultValue)) {
              consolidatedMap[indicatorKey].resultado += resultValue;
            }
          }

          // Sumar todos los términos numéricos
          Object.keys(indicator).forEach(key => {
            if (key === 'calculate_terms' || key === 'indicator_unit' ||
              key === 'histories' || key === 'result') {
              return; // Saltar metadatos
            }

            // Extraer valor numérico del string (ej: "22.8 m3" -> 22.8)
            const value = indicator[key];
            if (typeof value === 'string' || typeof value === 'number') {
              const numMatch = String(value).match(/[\d.]+/);
              if (numMatch) {
                const num = parseFloat(numMatch[0]);
                if (!isNaN(num)) {
                  if (!consolidatedMap[indicatorKey].terminos[key]) {
                    consolidatedMap[indicatorKey].terminos[key] = 0;
                  }
                  consolidatedMap[indicatorKey].terminos[key] += num;
                }
              }
            }
          });
        });
      });
    });
  });

  // Convertir el mapa a array y formatear los términos finales
  return Object.values(consolidatedMap).map(consolidated => {
    // Redondear resultado a 2 decimales
    const resultadoRedondeado = Number(consolidated.resultado.toFixed(2));

    // Formatear términos como un solo string legible
    const terminosStr = Object.keys(consolidated.terminos)
      .map(key => {
        const value = Number(consolidated.terminos[key].toFixed(2));
        return `${key}: ${value}`;
      })
      .join(' | ');

    return {
      indicador: consolidated.indicador,
      resultado: `${resultadoRedondeado} ${consolidated.unidad}`,
      terminos: terminosStr
    };
  });
}

export default parseReportToTable;